import Footer from "../Footer"
import Navbar from "../layouts/Navbar"

const Store = () => {
    return (
        <div>
            <Navbar />
            Store
            <Footer />
        </div>
    )
}

export default Store
